import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { AdminUpdateWorkItemParams } from '@/shared/api/requests/work/admin-update-work-item/request';
import { adminUpdateWorkItem } from '@/shared/api/requests/work/admin-update-work-item/request';

export const useAdminUpdateWorkItemMutation = (
  settings?: MutationSettings<AdminUpdateWorkItemParams, typeof adminUpdateWorkItem>
) =>
  useMutation({
    mutationKey: ['AdminUpdateWorkItem'],
    mutationFn: ({ params, config }) =>
      adminUpdateWorkItem({
        params,
        config
      }),
    ...settings?.options
  });
